import React, {PureComponent} from 'react';
// import { withGoogleMap, GoogleMap, Marker, InfoWindow,Polyline } from 'react-google-maps';


class MyPolyline extends PureComponent {

    componentWillUpdate() {
      this.line.setMap(null)
    }
  
    componentWillUnmount() {
      this.line.setMap(null)
    }
  
    getPaths() {
      const { path } = this.props

      if (path) {
        var routeLatLng = []

        path.coordinates.forEach(element => {
          if (element.length == 2) {
            let coord = { lat: element[1], lng: element[0]}
            routeLatLng.push(coord)
          }
        });

        return routeLatLng
      } 

    }
  
    render() {
      const Polyline = this.props.maps.Polyline
  
      const renderedPolyline = this.renderPolyline()
      const paths = { path: this.getPaths() }
  
      this.line = new Polyline(Object.assign({}, renderedPolyline, paths))
  
      this.line.setMap(this.props.map)
  
      return null
    }
  
    renderPolyline() {
        return {
          geodesic: true,
          strokeColor: this.props.color || '#ffffff',
          strokeOpacity: 1,
          strokeWeight: 4
        }
      }
  
  }
  export default MyPolyline;